export const GHOST_COMP_STRUCTURE_OVERRIDES = {
	components: [],
	componentType: 'GhostComp',
	connectionQuery: '',
	uiType: '',
	slotsQuery: '', // remove slotsQuery pointer to avoid resolving slots for ghost comps in flattenStructure
}
